export default "__VITE_ASSET__CY0eoue5__"